module.exports = __webpack_public_path__ + "static/media/facebook.fed3b07f.png";